@if (this.Team) {
  <mat-card appearance="outlined" style="max-width: 570px; width: 570px; margin: 10px;" class="mat-elevation-z4">
    <mat-card-header>
      <mat-card-title>
        <img src="/assets/img/{{this.Team.SmallIconFileName}}" height="40px;"/>
        {{Team.Level}}
      </mat-card-title>
      <!--    <mat-card-subtitle>
      {{Team.Level}}
    </mat-card-subtitle>  -->
  </mat-card-header>
  <mat-card-content  >
    @if (this.Team.Access_PhysicalStatus) {
      <mat-divider></mat-divider>
    }
    @if (this.Team) {
      <app-team-physical-status-block [Team]="Team"></app-team-physical-status-block>
    }
    @if (this.Team.Access_Injury) {
      <mat-divider></mat-divider>
    }
    @if (this.Team?.Access_Injury) {
      <app-team-injury-block [Team]="Team"></app-team-injury-block>
      }<br/>
      @if (this.Team.Access_PlayerGameRankings) {
        <mat-divider></mat-divider>
      }
      @if (this.Team?.Access_PlayerGameRankings) {
        <app-team-games-block [Team]="Team"></app-team-games-block>
        }<br/>
        @if (this.Team.Access_Test) {
          <mat-divider></mat-divider>
        }
        @if (this.Team?.Access_Test) {
          <app-team-physical-test-block [Team]="Team"></app-team-physical-test-block>
          }<br/>
          <mat-divider></mat-divider>
        </mat-card-content>
      </mat-card>
    }
